import { render, staticRenderFns } from "./ShortKeysDialog.vue?vue&type=template&id=cbe69f12&scoped=true"
import script from "./ShortKeysDialog.vue?vue&type=script&lang=js"
export * from "./ShortKeysDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe69f12",
  null
  
)

export default component.exports